import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5133cc33"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Economic Tools", -1))
const _hoisted_2 = { class: "rounded-lg shadow-lg bg-white ring-1 ring-black ring-opacity-5 overflow-hidden" }
const _hoisted_3 = { class: "relative grid p-5" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b text-purple-400 font-bold pb-2" }, "The Infrastructure for a Global Data Economy", -1))
const _hoisted_5 = { class: "grid grid-cols-2" }
const _hoisted_6 = { class: "column" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("header", null, "Argon Stablecoin"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("p", null, "Universal micro-payments pegged to the Consumer Price Index.")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("header", null, "Federated Sidechain"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("p", null, "Fast settling transactional engine for permissionless data queries.")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("header", null, "Stabilization Bonds"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("p", null, "Financial mechanism to provide responsive algorithmic stabilization.")
], -1))
const _hoisted_10 = { class: "column" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("header", null, "Mining Operations"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("p", null, "Computational nodes that deliver data queries and mine the block chain.")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("header", null, "Revenue Generating NFTs"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("p", null, "Domains and Datastores as self-contained tradable business.")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("header", null, "External Services"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("p", null, "Services to simplify the setup and management of mining operations.")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")!
  const _component_PopoverButton = _resolveComponent("PopoverButton")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_NavItem = _resolveComponent("NavItem")!
  const _component_PopoverPanel = _resolveComponent("PopoverPanel")!
  const _component_Popover = _resolveComponent("Popover")!

  return (_openBlock(), _createBlock(_component_Popover, { class: "relative" }, {
    default: _withCtx(({ open }) => [
      _createVNode(_component_PopoverButton, {
        class: _normalizeClass([open ? 'text-gray-900' : 'font-light text-900', 'group inline-flex items-center hover:text-gray-900 focus:outline-none focus:ring-0'])
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createTextVNode(),
          _createVNode(_component_ChevronDownIcon, {
            class: _normalizeClass([open ? 'text-gray-600 rotate-180' : 'text-purple-900', 'h-4 w-4 ml-1 stroke-1 duration-100 group-hover:text-gray-500']),
            "aria-hidden": "true"
          }, null, 8, ["class"])
        ]),
        _: 2
      }, 1032, ["class"]),
      _createTextVNode(),
      _createVNode(_Transition, {
        "enter-active-class": "transition ease-out duration-200",
        "enter-from-class": "opacity-0 translate-y-1",
        "enter-to-class": "opacity-100 translate-y-0",
        "leave-active-class": "transition ease-in duration-150",
        "leave-from-class": "opacity-100 translate-y-0",
        "leave-to-class": "opacity-0 translate-y-1"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_PopoverPanel, { class: "absolute z-10 left-0 transform mt-3 px-2 w-screen max-w-3xl sm:px-0" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createTextVNode(),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("ul", null, [
                        _createVNode(_component_NavItem, { isComingSoon: true }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createVNode(_component_inline_svg, {
                                src: require('@/assets/tool-icons/argon.svg')
                              }, null, 8, ["src"]),
                              _createTextVNode(),
                              _hoisted_7
                            ])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(),
                        _createVNode(_component_NavItem, { isComingSoon: true }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createVNode(_component_inline_svg, {
                                src: require('@/assets/tool-icons/sidechain.svg')
                              }, null, 8, ["src"]),
                              _createTextVNode(),
                              _hoisted_8
                            ])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(),
                        _createVNode(_component_NavItem, { isComingSoon: true }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createVNode(_component_inline_svg, {
                                src: require('@/assets/tool-icons/bonds.svg')
                              }, null, 8, ["src"]),
                              _createTextVNode(),
                              _hoisted_9
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("ul", null, [
                        _createVNode(_component_NavItem, { isComingSoon: true }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createVNode(_component_inline_svg, {
                                src: require('@/assets/tool-icons/mining.svg')
                              }, null, 8, ["src"]),
                              _createTextVNode(),
                              _hoisted_11
                            ])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(),
                        _createVNode(_component_NavItem, { isComingSoon: true }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createVNode(_component_inline_svg, {
                                src: require('@/assets/tool-icons/nfts.svg')
                              }, null, 8, ["src"]),
                              _createTextVNode(),
                              _hoisted_12
                            ])
                          ]),
                          _: 1
                        }),
                        _createTextVNode(),
                        _createVNode(_component_NavItem, { isComingSoon: true }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createVNode(_component_inline_svg, {
                                src: require('@/assets/tool-icons/services.svg')
                              }, null, 8, ["src"]),
                              _createTextVNode(),
                              _hoisted_13
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}